import React from "react";

/**
 * Isolates crashes in the search bar (AI or manual mode) behind a
 * fallback UI with a retry action, so a search error can't take down
 * the rest of the page.
 */
class SearchErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
        this.handleRetry = this.handleRetry.bind(this);
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // console.error stands in for real logging/observability (Sentry,
        // Datadog, etc.) so this works out of the box with no extra setup.
        console.error("SearchBar crashed:", error, info);
        this.props.onError?.(error, info);
    }

    handleRetry() {
        this.setState({ hasError: false });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="search-pill-outer">
                    <div className="search-pill search-pill-fallback">
                        <span className="search-fallback-text">Search is temporarily unavailable.</span>
                        <button type="button" className="search-fallback-retry" onClick={this.handleRetry}>
                            Retry
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default SearchErrorBoundary;